// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".82fcd646bdc6b7b152db5fb419aa5909cbed5b3b.chunk.bundle.js";
};